import { http_client } from '@/plugins/http_client';

const URL_BASE = 'api/constancias';

/**
 * Obtiene la lista de constancias  
 * @param {Object} params - { buscar, estado, tipo_constancia, page, per_page }
 */
export const fetchConstancias = (params = {}) => {
  return http_client(`${URL_BASE}/listar-constancias`, params, 'POST');
};

// ─── Empleado ───────────────────────────────────────────────────────────────

/**
 * Crea una nueva solicitud de constancia.
 * @param {Object} data - { tipo_constancia_id }
 */
export const crearConstancia = (data = {}) => {
  return http_client(`${URL_BASE}`, data, 'POST');
};

/**
 * Descarga el documento PDF de una constancia aprobada.
 * @param {number|string} id
 */
export const descargarConstancia = (id) => {
  return http_client(`${URL_BASE}/${id}/descargar`, {}, 'GET');
};

/**
 * Obtiene el detalle de una constancia (para el modal de visualización).
 * @param {number|string} id
 */
export const verConstancia = (id) => {
  return http_client(`${URL_BASE}/${id}/ver`, {}, 'GET');
};

// ─── Jefe RRHH ──────────────────────────────────────────────────────────────

 
/**
 * Aprueba un conjunto de constancias seleccionadas.
 * @param {Object|number[]} payload - { ids: number[] } (compat: number[])
 */
export const aprobarConstancias = (payload = { ids: [] }) => {
  const requestBody = Array.isArray(payload) ? { ids: payload } : payload;
  return http_client(`${URL_BASE}/aprobar`, requestBody, 'PATCH');
};

/**
 * Aprueba una constancia individual.
 * @param {number|string} id
 * @param {Object} decision - { aprobacion: 'si', justificacion: '' }
 */
export const aprobarConstancia = (id, decision = { aprobacion: 'si', justificacion: '' }) => {
  return http_client(`${URL_BASE}/${id}/aprobacion`, decision, 'PATCH');
};

/**
 * Rechaza una constancia.
 * @param {number|string} id
 * @param {Object} decision - { aprobacion: 'no', justificacion: '...' }
 */
export const rechazarConstancia = (id, decision) => {
  return http_client(`${URL_BASE}/${id}/aprobacion`, decision, 'PATCH');
};

// ─── Catálogos ───────────────────────────────────────────────────────────────

/**
 * Obtiene el catálogo de tipos de constancia.
 */
export const fetchTiposConstancia = () => {
  return http_client('api/catalogos/tipos-constancia', {}, 'GET');
};

/**
 * Obtiene el catálogo de estados de constancia.
 */
export const fetchEstadosConstancia = () => {
  return http_client('api/constancias/estados', {}, 'GET');
};

export default {
  fetchConstancias,
  crearConstancia,
  descargarConstancia,
  verConstancia,
  aprobarConstancias,
  aprobarConstancia,
  rechazarConstancia,
  fetchTiposConstancia,
  fetchEstadosConstancia,
};
